module.exports = __webpack_public_path__ + "static/media/USA-California2.e3f0391f.jpg";